export const $ = jQuery;

window.$ = $;
